export const $ = jQuery;

window.$ = $;
